var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-snackbar",
    {
      attrs: { bottom: "", timeout: _vm.timeout },
      scopedSlots: _vm._u([
        {
          key: "action",
          fn: function (ref) {
            var attrs = ref.attrs
            return [
              _c(
                "v-btn",
                {
                  staticClass: "no-text-transform",
                  attrs: { dark: "", text: "" },
                  on: { click: _vm.closeClicked },
                },
                [_vm._v("\n            " + _vm._s(_vm.btnText) + "\n        ")]
              ),
              _vm._v(" "),
              _vm.showActivity
                ? _c("v-progress-circular", { attrs: { indeterminate: "" } })
                : _vm._e(),
            ]
          },
        },
      ]),
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [_vm._v("\n    " + _vm._s(_vm.message) + "\n    ")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }